import { render, staticRenderFns } from "./ReviewsCount.vue?vue&type=template&id=35b8e5bd&scoped=true&"
import script from "./ReviewsCount.vue?vue&type=script&lang=js&"
export * from "./ReviewsCount.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsCount.vue?vue&type=style&index=0&id=35b8e5bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b8e5bd",
  null
  
)

export default component.exports